module.exports = __webpack_public_path__ + "static/img/SearchDetailRetirement1.6d19546.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailRetirement1.png
// module id = 772
// module chunks = 0